import React, { Suspense, lazy, useEffect } from 'react';

import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
// import {getCLS, getFID, getLCP} from 'web-vitals';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import './App.scss';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useDarkMode } from '../src/config/themes/themeSwitcher';
import LazyLoader from './components/utils/lazyLoader';

import { ErrorBoundary } from 'react-error-boundary';
import LazyErrorComponent from './components/utils/lazyErrorComponent';

import LoginPage from './components/pages/loginPage';

import { useLocation } from 'react-router-dom';
import Signin from './components/login/loginPage';
import { Paper, Typography } from '@mui/material';
import oAuthAuthentication from './config/sso/microsoftsso';
import Backdrop from '@mui/material/Backdrop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FileScanningLoader } from './components/utils/fileScanningloader';
import { loginActions } from './actions/loginAction';
import useMediaQuery from '@mui/material/useMediaQuery';
import { datadogRum } from '@datadog/browser-rum';
// import { datadogLogs } from '@datadog/browser-logs';
import { reactPlugin } from '@datadog/browser-rum-react';
import GlobalStylingTheme from './components/utils/GlobalStyling';
/*components*/

const ExpensesPage = lazy(() => import('./components/pages/expenses'));
const MiniDrawer = lazy(() => import('./components/utils/header'));
const TimeOffPage = lazy(() => import('./components/pages/timeoff'));
const TimeSheetPage = lazy(() => import('./components/pages/timesheet'));
const Profile = lazy(() => import('./components/pages/profile'));
const ServiceRequests = lazy(() => import('./components/pages/serviceRequests'));
const Pagenotfound = lazy(() => import('./components/pages/pagenotfound'));
const MBOPage = lazy(() => import('./components/pages/mbo'));
const TeamPage = lazy(() => import('./components/pages/team'));
const OnBoarding = lazy(() => import('./components/pages/onboarding'));
const QuickOnboarding = lazy(
  () => import('./components/onboarding/QuickOnboarding/QuickOnboarding')
);
const DetailedOnboarding = lazy(() => import('./components/onboarding/newOnbarding'));
const ItGlobal = lazy(() => import('./components/pages/itGlobal'));
const reports = lazy(() => import('./components/pages/reports'));
const BenefitEnrollmentPage = lazy(() => import('./components/pages/benefitEnrollment'));
const PayRollPage = lazy(() => import('./components/pages/payRoll'));
const ATS = lazy(() => import('./components/pages/ATS'));
const ProjectMaintenance = lazy(() => import('./components/pages/ProjectMaintenance'));
const ProjectMaintenanceprojectDetails = lazy(
  () => import('./components/projectMaintenance/ProjectMaintenanceprojectDetailsUserlayout')
);
const ProjectMaintenanceCreate = lazy(
  () => import('./components/projectMaintenance/createOrEditProject')
);
const LeaveManagement = lazy(() => import('./components/pages/leaveManagement'));
const Templates = lazy(() => import('./components/pages/templates'));
const FinanceManager = lazy(() => import('./components/pages/FinanceManager'));
const ServiceBilling = lazy(() => import('./components/pages/ServiceBilling'));
const UpdateInvoicePage = lazy(() => import('./components/ServiceBilling/form/UpdateInvoice'));
const UpdateEmailPage = lazy(() => import('./components/ServiceBilling/form/UpdateEmail'));
const UpdateReceiptPage = lazy(() => import('./components/ServiceBilling/form/UpdateReceipt'));
const Jobs = lazy(() => import('./components/pages/Jobs'));
const ApplicantFromLinkedin = lazy(() => import('./components/pages/ApplicantFromLinkedin'));
const userPayrollPage = lazy(() => import('./components/pages/userPayrollPage'));
const RegularPay = lazy(() => import('./components/pages/RegularPayPage'));
const OffCyclePage = lazy(() => import('./components/pages/offCyclePage'));
const PayrollTaxDocuments = lazy(() => import('./components/pages/PayrollTaxDocuments'));
const DashBoard = lazy(() => import('./components/pages/DashBoard'));
const ProjectManagement = lazy(() => import('./components/pages/ProjectManagement'));
const ProjectManagementCreate = lazy(
  () => import('./components/ProjectManagement/CreateProject')
);
const PreivewPMcase = lazy(() => import('./components/ProjectManagement/PreviewPMCase'));
const ResourceNeed = lazy(() => import('./components/ProjectManagement/CreateResourceNeed'));
const PayrollDeduction = lazy(() => import('./components/pages/PayrollDeduction'));
const CreateClient = lazy(() => import('./components/projectMaintenance/CreateClient'));
const CreateInvoice = lazy(() => import('./components/projectMaintenance/CreateInvoice'));
const AddDeductions = lazy(() => import('./components/PayrollDeduction/AddDeductions'));
const AddExemptions = lazy(() => import('./components/PayrollDeduction/AddExemptions'));
const CloseProjectPM = lazy(() => import('./components/ProjectManagement/CloseProject'));
const UpdateProject = lazy(() => import('./components/ProjectManagement/UpdateProject'));
const EmployeePaystub = lazy(() => import('./components/payRoll/EmployeePaystub'));
const YearWisePaystub = lazy(() => import('./components/payRoll/YearWisepayStubs'));
const I9Employee = lazy(() => import('./components/onboarding/i9/I9Employee'));
const Terms = lazy(() => import('./components/terms/terms'));

// Runs once per browser refresh. Service Billing remembers its list view
// (group by, open groups, page) in sessionStorage so Back from a case page
// returns to it. A refresh resets that view — except when it happens on a
// Service Billing case page (Update Invoice / Email / Receipt), so Back from
// there still returns to where the case was opened.
if (!/^#\/serviceBilling\/.+/i.test(window.location.hash)) {
  try {
    sessionStorage.removeItem('__serviceBilling_groupBy__');
    sessionStorage.removeItem('__grid_view__serviceBilling');
  } catch (e) {}
}

// import PerformanceAppraisal from './components/pages/performanceappraisal';

// getCLS(console.log);
// getFID(console.log);
// getLCP(console.log);

const SSOLogin = window.isSSO;

const PrivateRoute = ({ component: Component, name, ...rest }) => {
  let getModules = localStorage.getItem('modules')
    ? localStorage.getItem('modules').trim().split(',')
    : '';

  getModules.push('dashboard');
  return (
    <Route
      {...rest}
      render={(props) =>
        getModules.indexOf(name) !== -1 ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/404' }} />
        )
      }
    />
  );
};

const useStyles = makeStyles(() => {
  const theme = useTheme();

  return {
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),

      // necessary for content to be below app bar
      [theme.breakpoints.up('sm')]: {
        ...theme.mixins.toolbar,
      },
    },
    content: {
      flexGrow: 1,
      // padding: theme.spacing(2),
      marginTop: '70px',
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(9),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0),
      },
    },
    shiftTextLeft: {
      marginLeft: '0px',
    },
    shiftTextRight: {
      marginLeft: '180px',
    },
    appBodyBackground: {
      backgroundColor: theme.palette.grey[100],
    },
    loaderScanning: {
      display: 'flex',
      alignItems: 'end',
    },
    success: {
      background: 'linear-gradient(94.77deg, #0CA63A -6.68%, #0A8633 113.45%) !important',
      color: '#fff !important',
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      borderRadius: '12px',
      fontSize: '12px !important',
    },
    error: {
      background: 'linear-gradient(95.46deg, #F6743E -6.96%, #D42525 108.25%) !important',
      color: '#fff !important',
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      borderRadius: '12px',
      fontSize: '12px !important',
    },
    customProgress: {
      background: '#ffffff66 !important',
      borderRadius: '15px !important',
    },
  };
});

function BodyContent({ setIsJobsEnabled }) {
  const theme = useTheme();
  const classes = useStyles();
  const isToolBarOpen = useSelector((state) => state.globalReducer.isToolBarOpen) === true;
  const location = useLocation();

  useEffect(() => {
    setIsJobsEnabled(
      location?.pathname.includes('/jobs') || location?.pathname.includes('/terms')
    );
  }, [location.pathname]);
  const mobileMatchMediaQuery = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <main
      style={{
        marginLeft: isToolBarOpen && !mobileMatchMediaQuery ? '166px' : '0px',
      }}
      className={clsx(
        { [classes.content]: true },
        // { [classes.shiftTextLeft]: !isToolBarOpen },
        // { [classes.shiftTextRight]: isToolBarOpen },
        { [classes.appBodyBackground]: true }
      )}>
      {/* <div className={classes.toolbar} /> */}
      <Switch>
        <PrivateRoute exact path="/expenses" name="ExpensesPage" component={ExpensesPage} />
        <PrivateRoute exact path="/timeoff" name="TimeOffPage" component={TimeOffPage} />
        <PrivateRoute exact path="/timesheet" name="TimeSheetPage" component={TimeSheetPage} />
        <PrivateRoute exact path="/" name="Profile" component={Profile} />
        <Route exact path="/404" component={Pagenotfound} />
        <PrivateRoute
          exact
          path="/servicerequests"
          name="ServiceRequests"
          component={ServiceRequests}
        />
        <PrivateRoute exact path="/MBOPage" name="MBOPage" component={MBOPage} />
        <PrivateRoute exact path="/SRFulfilment" name="SRFulfilment" component={ItGlobal} />
        <PrivateRoute path="/team" name="Team" component={TeamPage} />
        <PrivateRoute exact path="/onboarding" name="OnBoarding" component={OnBoarding} />
        <PrivateRoute
          exact
          path="/onboarding/QuickOnboarding"
          name="OnBoarding"
          component={OnBoarding}
        />
        <PrivateRoute
          exact
          path="/onboarding/QuickOnboarding/:caseID"
          name="OnBoarding"
          component={OnBoarding}
        />
        <PrivateRoute
          exact
          path="/onboarding/DetailedOnboarding"
          name="OnBoarding"
          component={OnBoarding}
        />
        <PrivateRoute
          exact
          path="/onboarding/DetailedOnboarding/:caseID"
          name="OnBoarding"
          component={OnBoarding}
        />
        <PrivateRoute exact path="/reports" name="reports" component={reports} />
        <PrivateRoute exact path="/templates" name="templates" component={Templates} />
        <PrivateRoute
          exact
          path="*/remuneration"
          name="remuneration"
          component={userPayrollPage}
        />
        <PrivateRoute
          exact
          path="/financeManager"
          name="financeManager"
          component={FinanceManager}
        />
        <PrivateRoute
          exact
          path="/serviceBilling"
          name="serviceBilling"
          component={ServiceBilling}
        />
        <PrivateRoute
          exact
          path={[
            '/serviceBilling/:status/updateInvoice/:caseId?',
            '/serviceBilling/updateInvoice/:caseId?',
          ]}
          name="serviceBilling"
          component={UpdateInvoicePage}
        />
        <PrivateRoute
          exact
          path={[
            '/serviceBilling/:status/updateEmail/:caseId?',
            '/serviceBilling/updateEmail/:caseId?',
          ]}
          name="serviceBilling"
          component={UpdateEmailPage}
        />
        <PrivateRoute
          exact
          path={[
            '/serviceBilling/:status/updateReceipt/:caseId?',
            '/serviceBilling/updateReceipt/:caseId?',
          ]}
          name="serviceBilling"
          component={UpdateReceiptPage}
        />
        <PrivateRoute
          exact
          path="/benefitenrollment"
          name="BenefitEnrollment"
          component={BenefitEnrollmentPage}
        />
        <PrivateRoute exact path="*/PayRoll" name="PayRoll" component={PayRollPage} />
        <PrivateRoute
          exact
          path="*/PayRoll/TaxDocuments"
          name="PayRoll"
          component={PayrollTaxDocuments}
        />
        <PrivateRoute
          exact
          path="*/PayRoll/EmployeePaystub"
          name="PayRoll"
          component={EmployeePaystub}
        />
        <PrivateRoute
          exact
          path="*/PayRoll/year_wise_paystub"
          name="PayRoll"
          component={YearWisePaystub}
        />
        <PrivateRoute
          exact
          path="*/PayRoll/RegularPay"
          name="PayRoll"
          component={RegularPay}
        />
        <PrivateRoute
          exact
          path="*/PayRoll/Regularpay/:payRollCaseId/:CaseType"
          name="PayRoll"
          component={RegularPay}
        />
        <PrivateRoute
          exact
          path="*/PayRoll/:payrollType"
          name="PayRoll"
          component={OffCyclePage}
        />
        <PrivateRoute
          exact
          path="*/PayRoll/:payrollType/:payRollCaseId/:CaseType"
          name="PayRoll"
          component={OffCyclePage}
        />
        <PrivateRoute
          exact
          path="*/remuneration/:payrollPage"
          name="remuneration"
          component={userPayrollPage}
        />
        <PrivateRoute exact path="/ATS" name="ATS" component={ATS} />
        <PrivateRoute
          exact
          path="/LeaveManagement"
          name="LeaveManagement"
          component={LeaveManagement}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/createClientMangement/:caseId?"
          name="ProjectMaintenance"
          component={CreateClient}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/view/createClientMangement/:caseId"
          name="ProjectMaintenance"
          component={CreateClient}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/saved/createClientMangement/:caseId"
          name="ProjectMaintenance"
          component={CreateClient}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/:caseId/:HCMOrg"
          name="ProjectMaintenance"
          component={ProjectMaintenanceprojectDetails}
        />
        {/*  */}

        <PrivateRoute
          exact
          path="/projectMaintenance/update/:caseId/:HCMOrg/:action"
          name="ProjectMaintenance"
          component={ProjectMaintenanceCreate}
        />

        <PrivateRoute
          exact
          path="/projectMaintenance/Resource/:caseId/:HCMOrg/:type"
          name="ProjectMaintenance"
          component={UpdateProject}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/update/:caseId/:type"
          name="ProjectMaintenance"
          component={UpdateProject}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/close/:caseId/:type"
          name="ProjectMaintenance"
          component={CloseProjectPM}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/:action/cases/:caseId"
          name="ProjectMaintenance"
          component={ProjectMaintenanceCreate}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/invoice/create/:projectCode"
          name="ProjectMaintenance"
          component={CreateInvoice}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance/:action"
          name="ProjectMaintenance"
          component={ProjectMaintenanceCreate}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/createClientMangement/:caseId?"
          name="ProjectManagement"
          component={CreateClient}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/view/createClientMangement/:caseId"
          name="ProjectManagement"
          component={CreateClient}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/saved/createClientMangement/:caseId"
          name="ProjectManagement"
          component={CreateClient}
        />
        <PrivateRoute
          exact
          path="/projectMaintenance"
          name="ProjectMaintenance"
          component={ProjectMaintenance}
        />
        <PrivateRoute exact path="/dashboard" name="dashboard" component={DashBoard} />
        <PrivateRoute
          exact
          path="/ProjectManagement"
          name="ProjectManagement"
          component={ProjectManagement}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/Create"
          name="ProjectManagement"
          component={ProjectManagementCreate}
        />

        <PrivateRoute
          exact
          path="/ProjectManagement/invoice/create/:projectCode"
          name="ProjectManagement"
          component={CreateInvoice}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/CloseProject/:caseId"
          name="ProjectManagement"
          component={CloseProjectPM}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/update/:caseId/Manage"
          name="ProjectManagement"
          component={ProjectManagementCreate}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/update/:caseId/:type"
          name="ProjectManagement"
          component={UpdateProject}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/savedcase/:savedCaseID/:type"
          name="ProjectManagement"
          component={UpdateProject}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/Create/:caseId/:type"
          name="ProjectManagement"
          component={ProjectManagementCreate}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/:caseId/:type"
          name="ProjectManagement"
          component={PreivewPMcase}
        />
        <PrivateRoute
          exact
          path="/ProjectManagement/ResourceNeed/:mode/:caseId/:type"
          name="ProjectManagement"
          component={ResourceNeed}
        />
        <PrivateRoute
          exact
          path="/PayrollConfigurations"
          name="PayrollConfigurations"
          component={PayrollDeduction}
        />
        <PrivateRoute
          exact
          path="/PayrollConfigurations/addDeduction"
          name="PayrollConfigurations"
          component={AddDeductions}
        />
        <PrivateRoute
          exact
          path="/PayrollConfigurations/AddExemptions"
          name="PayrollConfigurations"
          component={AddExemptions}
        />
        <PrivateRoute exact path="/I9" name="I9" component={I9Employee} />
      </Switch>
    </main>
  );
}
function MainContainer({
  setIsJobsEnabled,
  isUserLoggedIn,
  theme,
  isJobsEnabled,
  toggleTheme,
}) {
  const location = useLocation();

  useEffect(() => {
    setIsJobsEnabled(
      location?.pathname.includes('/jobs') || location?.pathname.includes('/terms')
    );
  }, [location.pathname]);

  return (
    <React.Fragment>
      {isJobsEnabled ? (
        <Switch>
          <Jobs exact path="/jobs" name="Jobs" component={Jobs} />
          <Terms exact path="/terms" name="Terms" component={Terms} />
          <ApplicantFromLinkedin
            exact
            path="/jobs/:id"
            name="Jobs"
            component={ApplicantFromLinkedin}
          />
        </Switch>
      ) : (
        <React.Fragment>
          {isUserLoggedIn ? (
            <React.Fragment>
              {!isJobsEnabled && (
                <MiniDrawer customTheme={theme} setCustomTheme={toggleTheme} />
              )}

              <ErrorBoundary fallback={<LazyErrorComponent />}>
                <Suspense fallback={<LazyLoader />}>
                  <BodyContent setIsJobsEnabled={setIsJobsEnabled} />
                </Suspense>
              </ErrorBoundary>
            </React.Fragment>
          ) : (
            <LoginPage SSOLogin={SSOLogin} Signin={Signin} />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
export default function App() {
  const [theme, toggleTheme, themeConfig, color] = useDarkMode();
  const classes = useStyles();
  const [isJobsEnabled, setIsJobsEnabled] = React.useState(false);
  const dispatch = useDispatch();

  const isUserLoggedIn = useSelector((state) => state.loggedIn.isLoggedIn);

  const uplaodedFileScanLoader = useSelector((state) => state.loggedIn.uplaodedFileScanLoader);

  // to be removed after theming

  // if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
  //   localStorage.setItem('theme', 'light');
  // } else {
  //   localStorage.setItem('theme', 'dark');
  // }

  localStorage.setItem('theme', 'light');

  // useEffect(() => {
  //   if (process.env.NODE_ENV === 'development') return;

  //   const handleKeyDown = (event) => {
  //     // Check if Ctrl+Shift+C is pressed
  //     if (
  //       (event.ctrlKey && event.shiftKey && event.key?.toLowerCase() === 'c') ||
  //       (event.metaKey && event.shiftKey && event.key?.toLowerCase() === 'c')
  //     ) {
  //       alert('Due to security reason,debug mode is not allowed.');
  //       event.preventDefault();
  //       // Prevent the default behavior (e.g., opening browser console)
  //       // Optionally, you can show a message or perform some other action here
  //     }
  //   };

  //   // Attach the event listener when the component mounts
  //   window.addEventListener('keydown', handleKeyDown);

  //   // Remove the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);

  useEffect(() => {
    if (window.isSSO && isUserLoggedIn) {
      dispatch(loginActions.ProfilePic());
      dispatch(loginActions.ProfilePicLoader());
    }
  }, [dispatch, isUserLoggedIn]);

  datadogRum.init({
    applicationId: '67e3fdbd-ae4e-4ea7-bb5b-23e0a9b5e822',
    clientToken: 'pub43c48d6a8c7f066dd6693f325e7c311d',
    site: 'us5.datadoghq.com',
    service: 'pega-react',
    env: 'prod',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
  });

  // datadogRum.startSessionReplayRecording();

  // // Logging
  // datadogLogs.init({
  //   clientToken: 'pub43c48d6a8c7f066dd6693f325e7c311d',
  //   site: 'us5.datadoghq.com',
  //   forwardErrorsToLogs: true,
  //   sampleRate: 100,
  // });
  return (
    <Paper style={color}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={uplaodedFileScanLoader}>
        <div className={classes.loaderScanning}>
          <Typography variant="h4">Scanning File...</Typography>
          <FileScanningLoader />
        </div>
      </Backdrop>

      <HashRouter>
        <Suspense fallback={<LazyLoader isJobsEnabled={isJobsEnabled} />}>
          <ThemeProvider theme={GlobalStylingTheme}>
            <ToastContainer
              theme="colored"
              autoClose={3000}
              closeOnClick
              hideProgressBar={true}
              pauseOnHover
              toastClassName={({ type }) => {
                switch (type) {
                  case 'success':
                    return classes.success;
                  case 'error':
                    return classes.error;
                  default:
                    return '';
                }
              }}
              progressClassName={classes.customProgress}
            />
            <MainContainer
              theme={theme}
              isUserLoggedIn={isUserLoggedIn}
              setIsJobsEnabled={setIsJobsEnabled}
              isJobsEnabled={isJobsEnabled}
              toggleTheme={toggleTheme}
            />
          </ThemeProvider>
        </Suspense>
      </HashRouter>
    </Paper>
  );
}

// <Route exact path="/servicerequests" component={ServiceRequests} />
// <PrivateRoute exact path="/performanceappraisal" name = "PerformanceAppraisal" component={PerformanceAppraisal} />
